module.exports = __webpack_public_path__ + "static/media/gradient.0ef7e5a7.png";